import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const CityConditions = memo(({ temperature, highTemperature, lowTemperature, description, tempUnitAbbreviations }) => {
    return (
        <Conditions>
            <Temperature>
                <Current>
                    {temperature}°
                </Current>
                <High>
                    Hi {highTemperature}{tempUnitAbbreviations}
                </High>
                <Low>
                    Lo {lowTemperature}{tempUnitAbbreviations}
                </Low>
            </Temperature>
            <Summary>
                {description}
            </Summary>
        </Conditions>
    );
});

CityConditions.displayName = 'CityConditions';
CityConditions.propTypes = {
    temperature: PropTypes.number,
    highTemperature: PropTypes.string,
    lowTemperature: PropTypes.string,
    tempDisplayUnit: PropTypes.string,
    description: PropTypes.string,
    tempUnitAbbreviations: PropTypes.string
};

const Conditions = styled.div`
    margin-left: 12px;
`;

const Temperature = styled.div`
    font-size: 0;
    line-height: 1.1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

const Current = styled.div`
    font-size: 28px;
    font-weight: 600;
    color: #435560;
`;

const High = styled.div`
    margin-left: 12px;
    font-size: 16px;
    font-weight: 400;
    color: #435560;
`;

const Low = styled.div`
    margin-left: 16px;
    font-size: 16px;
    font-weight: 400;
    color: #435560;
`;

const Summary = styled.div`
    font-size: 16px;
    font-weight: 600;
    color: #435560;
`;
